function toggleAutoRenewal(x, me) {
    showLoader(me);
    $.ajax({
        url: "/toggleSub",
        type: 'post',
        data: { id: x },
        dataType: 'JSON',
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        success: function(response) {
            if (response.cancel_at_period_end) {
                toggleAutoRenewalVisual(response, me);
            } else {
                toggleAutoRenewalVisual(response, me);
            }
        }
    });
}

function toggleAutoRenewalVisual(json, me) {
    hideAll(me);

    if (json.cancel_at_period_end) {
        $(me).find(".renew-button-off").removeClass("d-none");
        $($(me).find(".renew-inactive")).text("Ends " + json.cancel_at);
        $(me).find(".renew-active").addClass("d-none");
        $(me).find(".renew-inactive").removeClass("d-none");
    } else {
        $(me).find(".renew-button-on").removeClass("d-none");
        $($(me).find(".renew-active")).text("Renews " + json.current_period_end);
        $(me).find(".renew-active").removeClass("d-none");
        $(me).find(".renew-inactive").addClass("d-none");
    }
}

function showLoader(me) {
    hideAll(me);
    $(me).find('.renew-loader').removeClass('d-none');
}

function bindAutoRenewalButtons() {
    $('#subscriptions .active-sub').each(function() {
        var me = this;
        $(this).find(".renew-button").on('click', function() {
            toggleAutoRenewal($(this).next().val(), me);
        });
        // $(this).find('.sub-info-icon').on('click', function() {
        //     let id = $(me).find('.renew-value').val();
        //     getBundleInfo(undefined, id);

        // });
    });
    $("#subscriptions .inactive-sub").each(function() {
        var me = this;
        $(this).find(".add-to-cart").on('click', function() {
            var button = this;
            addToCart($(me).find('.renew-value').val()).done(function(response) {
                if (response.status == 'success') {
                    $(button).text("Added!");
                    updateCartIcon();
                }
            });
        });
        $(this).find('.sub-info-icon').on('click', function() {
            let id = $(me).find('.renew-value').val();
            getBundleInfo(undefined, id);
        });
    });
}

function hideAll(me) {
    $(me).find(".renew-button").children().each(function() {
        $(this).addClass('d-none');
    });
}

function showCart(x) {
    $.ajax({
        url: "/emptyCart",
        type: 'post',
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        success: function(response) {
            $("#cart-quantity").html(response);
        }
    });
}

// function prepPopup(x) {
//     return $.ajax({
//         url: "/getSubInfo",
//         type: 'post',
//         data: {id: x},
//         dataType: 'JSON',
//         headers: {
//             'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
//         },
//     });
// }


window.toggleAutoRenewalVisual = toggleAutoRenewalVisual;
window.toggleAutoRenewal = toggleAutoRenewal;
window.bindAutoRenewalButtons = bindAutoRenewalButtons;
window.hideAll = hideAll;
window.showCart = showCart;
// window.prepPopup = prepPopup;